/**
 * 指定された時間だけ待った後に解決されるプロミスを返す。
 * setTimeoutをプロミスにしたもの。
 * 精度が低く、例えば`wait(100)`を10回読んでも1秒になる保証はないため注意。
 * 「およそこのくらい待つ」という目的に使うこと。
 *
 * @example
 * ```typescript
 * alert("hi!");
 * await wait(5000);
 * alert("5 seconds later!");
 * ```
 *
 * @param ms 待機時間(ミリ秒)
 * @param signal 待機キャンセル処理のシグナル
 * @returns 待機処理のプロミス
 */
export const wait = async (ms: number, signal?: AbortSignal) => {
    if (ms <= 0 || !Number.isSafeInteger(ms)) {
        throw new Error(`ms should be a positive integer. ms: ${ms}`);
    }

    if (signal?.aborted) {
        throw new DOMException("Aborted", "AbortError");
    }

    return new Promise<void>((res, rej) => {
        const timeoutId = setTimeout(() => { res(); }, ms);

        signal?.addEventListener("abort", () => {
            clearTimeout(timeoutId);
            rej(new DOMException("Aborted", "AbortError"));
        }, { once: true });
    });
};
